function scrollToDirectLink() {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  const scrollTo = searchParams.get("scroll");
  console.log({ scrollTo });
  if (!scrollTo) return null;

  const scrollToElement = document.getElementById(scrollTo);
  console.log({ scrollToElement });
  if (!scrollToElement) return null;
  autoScrollElementTop(scrollToElement, 100);
  setTimeout(() => {}, 5000);
}
scrollToDirectLink();

function autoScrollElementTop(element, offset = 150) {
  if (element != null) {
    const position = element.getBoundingClientRect();
    window.scroll({
      top: position.top + window.scrollY - offset,
      left: 0,
      behavior: "smooth",
    });
  }
}
